import magicStyles from './quick-deposit.magic.css.js';
import QuickDepositComponent from './quick-deposit.js';
import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';

const __vue_script__ = QuickDepositComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.savedCards.length
    ? _c(
        "div",
        {
          staticClass: "quick-deposit",
          class: { "is-mobile": _vm.isMobile },
          attrs: {
            part: _vm.$p("quick-deposit", { "is-mobile": _vm.isMobile }),
            "data-v-test-id": "quick-deposit"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "content",
              class: { "content--vertical": _vm.vertical },
              attrs: {
                part: _vm.$p("content", { "content--vertical": _vm.vertical })
              }
            },
            [
              _c("magic-ui-dropdown", {
                staticClass: "card",
                class: { "card--vertical": _vm.vertical },
                attrs: {
                  small: "",
                  "icon-prefix": "creditcard-wire",
                  part: _vm.$p("card", { "card--vertical": _vm.vertical }),
                  "data-v-test-id": "quick-deposit-card-dropdown",
                  value: _vm.selectedCard
                },
                domProps: { options: _vm.savedCards },
                on: {
                  change: function($event) {
                    _vm.selectedCard = $event.detail[0];
                  }
                }
              }),
              _vm._v(" "),
              _c("magic-ui-number", {
                staticClass: "cvv",
                class: { "cvv--vertical": _vm.vertical },
                attrs: {
                  small: "",
                  maxlength: "4",
                  part: _vm.$p("cvv", { "cvv--vertical": _vm.vertical }),
                  placeholder: _vm.$t("quick-deposit.card-cvv"),
                  "data-v-test-id": "quick-deposit-cvv-number",
                  value: _vm.cvv
                },
                on: {
                  focus: function($event) {
                    return _vm.onFocus()
                  },
                  input: function($event) {
                    _vm.cvv = $event.detail[0];
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "magic-ui-tooltip",
                {
                  staticClass: "amount error lifted",
                  class: { "amount--vertical": _vm.vertical },
                  attrs: {
                    controlled: "",
                    part: _vm.$p("amount error lifted", {
                      "amount--vertical": _vm.vertical
                    }),
                    position: _vm.toolTipPosition,
                    "is-controlled-open": !!_vm.limitsMessage,
                    label: _vm.limitsMessage,
                    "data-v-test-id": "quick-deposit-amount-tooltip"
                  }
                },
                [
                  _c("magic-ui-number", {
                    attrs: {
                      small: "",
                      maxlength: "4",
                      placeholder: _vm.currency,
                      "data-v-test-id": "quick-deposit-amount-number",
                      value: _vm.amount
                    },
                    on: {
                      input: [
                        function($event) {
                          _vm.amount = $event.detail[0];
                        },
                        function($event) {
                          return _vm.onChangeAmount()
                        }
                      ],
                      focus: function($event) {
                        return _vm.onFocus()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isMobile && !_vm.vertical
                ? [
                    _c(
                      "magic-ui-button",
                      {
                        staticClass: "button button--icon",
                        attrs: {
                          icon: "",
                          round: "",
                          "no-margin": "",
                          "no-padding": "",
                          part: "button button--icon",
                          variant: "primary",
                          disabled: _vm.depositDisabled,
                          loading: _vm.paymentProcessing,
                          "data-v-test-id": "quick-deposit-button"
                        },
                        on: { click: _vm.onDeposit }
                      },
                      [
                        _c("magic-ui-icon", {
                          staticClass: "icon icon--deposit",
                          attrs: { name: "plus", part: "icon icon--deposit" }
                        })
                      ],
                      1
                    )
                  ]
                : [
                    _c("magic-ui-button", {
                      staticClass: "button button--label",
                      class: { "button--vertical": _vm.vertical },
                      attrs: {
                        small: "",
                        "no-margin": "",
                        variant: "primary",
                        part: _vm.$p("button button--label", {
                          "button--vertical": _vm.vertical
                        }),
                        disabled: _vm.depositDisabled,
                        loading: _vm.paymentProcessing,
                        wide: _vm.vertical,
                        "data-v-test-id": "quick-deposit-button"
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("quick-deposit.deposit"))
                      },
                      on: { click: _vm.onDeposit }
                    })
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide-in" } }, [
            _vm.showSuccessMessage || _vm.showErrorMessage
              ? _c(
                  "div",
                  { staticClass: "wrapper", attrs: { part: "wrapper" } },
                  [
                    _c(
                      "div",
                      { staticClass: "result", attrs: { part: "result" } },
                      [
                        _vm.showSuccessMessage
                          ? [
                              _c("magic-ui-icon", {
                                staticClass: "icon icon--payment",
                                attrs: {
                                  name: "quick-deposit-success",
                                  part: "icon icon--payment"
                                }
                              }),
                              _vm._v(" "),
                              _c("magic-ui-text", {
                                staticClass: "text",
                                attrs: {
                                  part: "text",
                                  content: _vm.$t(
                                    "quick-deposit.deposit-successful"
                                  ),
                                  "data-v-test-id":
                                    "quick-deposit-success-message"
                                }
                              })
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showErrorMessage
                          ? [
                              _c("magic-ui-icon", {
                                staticClass: "icon icon--payment",
                                attrs: {
                                  name: "quick-deposit-failed",
                                  part: "icon icon--payment"
                                }
                              }),
                              _vm._v(" "),
                              _c("magic-ui-text", {
                                staticClass: "text",
                                attrs: {
                                  part: "text",
                                  content: _vm.$t(
                                    "quick-deposit.deposit-failed"
                                  ),
                                  "data-v-test-id": "quick-deposit-fail-message"
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-ccf6915a_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-ccf6915a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
